import protoRoot from "../proto-root";

function create({ cameraId }) {
  const CameraAndFlashlightState = protoRoot.lookupType(
    `comm.CameraAndFlashlightState`
  );

  return CameraAndFlashlightState.create({
    flashlightAvailable: false,
    flashlightEnabled: false,
    flashlightAdjustable: false,
    flashlightIntensity: 0,
    cameraId
  });
}

export default {
  create
};

// message CameraAndFlashlightState {
//     bool flashlightAvailable = 1;
//     bool flashlightEnabled = 2;
//     bool flashlightAdjustable = 3;
//     float flashlightIntensity = 4;
//     string cameraId = 5; // nový parametr nesoucí id vybrané kamery
// }
